import { getCookie } from "../../helper/cookieHelper";

const state = () => ({
	id: null,
	variant: null,
	isInitialized: false
});

const mutations = {
	setId(state, id) {
		state.id = id;
	},
	setVariant(state, variant) {
		state.variant = variant;
	},
	setIsInitialized(state) {
		state.isInitialized = true;
	}
};

const actions = {
	checkCookie({ commit }) {
		const cookieValue = getCookie("wk");

		if (cookieValue) {
			const [id, variant] = cookieValue.split(".");

			commit("setId", id);
			commit("setVariant", variant);

			const htmlElement = document.documentElement;
			const newHtmlClass = "variation-" + variant;

			htmlElement.classList.forEach(function(className) {
				if (className.startsWith("variation-") && className !== newHtmlClass) {
					htmlElement.classList.remove(className);
				}
			});

			if (!htmlElement.classList.contains(newHtmlClass)) {
                htmlElement.classList.add(newHtmlClass);
            }
		}

		commit("setIsInitialized");
	}
};

const getters = {
	isId: state => id => {
		return state.id === id;
	},
	isVariant: state => key => {
		return state.variant && state.variant === key;
	},
	hasSomeVariant: state => {
		return state.variant !== null;
	},
	isInitialized: state => {
		return state.isInitialized;
	}
};

export default {
	namespaced: true,
	actions,
	state,
	mutations,
	getters
};
